<template>
  <div class="kick-btn">
   
  </div>
</template>

<script>

export default {
  data() {
    return {};
  },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/Home/KickstarterCTA.vue